export default {
  organisationReportCommentsCounter() {
    return this.organisationReportComments || 0;
  },
  overnightCommentsCounter() {
    return this.overnightComments || 0;
  },
};
